import { API_WORKFLOW_REQ_CATEGORIES } from "./API_CONSTANTS";
import { BaseService } from './baseService';

export class WorkflowReqCategoryService extends BaseService {
    constructor() {
        super(API_WORKFLOW_REQ_CATEGORIES);
    }
}
